import { useTranslation } from 'react-i18next';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function Bonuses() {
  const { t } = useTranslation();

  const bonus = {
    title: t('phoenix.bonusPromptsTitle'),
    value: t('phoenix.bonusPromptsValue'),
    desc: t('phoenix.bonusPromptsDesc'),
    imgSrc: 'https://readdy.ai/api/search-image?query=Premium%20digital%20product%20mockup%20displaying%20AI%20advertising%20prompts%20library%20on%20a%20modern%20laptop%20screen%2C%20sleek%20minimalist%20interface%20with%20organized%20prompt%20categories%2C%20white%20clean%20background%2C%20elegant%20typography%2C%20red%20and%20gold%20accents%2C%20professional%20editorial%20photography%2C%20soft%20natural%20lighting%2C%20modern%20desk%20setup&width=800&height=600&seq=phoenix-bonus-prompts-01&orientation=landscape',
  };

  return (
    <section className="relative py-20 md:py-28 bg-white">
      <div className="mx-auto max-w-[1200px] px-6 md:px-10">
        <ScrollReveal direction="up">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-50 border border-accent-200/50 text-accent-700 text-xs font-semibold tracking-wide uppercase mb-4">
            {t('phoenix.bonusTag')}
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-16">
            {t('phoenix.bonusHeading').split('<span>')[0]}
            <span className="text-accent-500">{t('phoenix.bonusHeading').split('<span>')[1]?.split('</span>')[0]}</span>
            {t('phoenix.bonusHeading').split('</span>')[1] || ''}
          </h2>
        </ScrollReveal>

        <div className="max-w-[600px] mx-auto">
          <ScrollReveal direction="up" delay={0.1}>
            <div className="group relative rounded-3xl bg-white border border-background-200/70 shadow-[0_4px_24px_rgba(0,0,0,0.04)] overflow-hidden hover:shadow-[0_8px_40px_rgba(0,0,0,0.08)] hover:-translate-y-1 transition-all duration-500">
              <div className="absolute top-4 left-4 z-10">
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-500/10 border border-accent-500/20 text-accent-700 text-xs font-bold">
                  <i className="ri-gift-line"></i>
                  BONUS
                </span>
              </div>
              <div className="h-52 overflow-hidden">
                <img
                  src={bonus.imgSrc}
                  alt={bonus.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-6 md:p-7">
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-2">{bonus.title}</h3>
                <p className="text-foreground-500 text-sm leading-relaxed mb-4">{bonus.desc}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400 font-medium uppercase tracking-wide">{t('phoenix.bonusLabel')}</span>
                  <span className="font-heading text-lg font-bold text-accent-600">{bonus.value}</span>
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}